import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import md5 from 'md5';

import CloseIcon from '@material-ui/icons/Cancel';
import { ProcessIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

import FilterMenu from './FilterMenu';
import Family from './ExpandFamily';


function toolbar(handleFilter, nofiltered) {
    const aux = [];
    aux.push(
        <FilterIcon
            disabled
            key={'hide-menu-toolbar'}
            color={nofiltered ? 'primary' : 'secondary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

class ListValues extends React.Component {

    state = {
        open: false,
        error: undefined,
        report_employee: undefined,
        message: undefined,
        hide: [],
        shownlocals: [],
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter, true)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { report_employee } = props;
        if (report_employee !== state.report_employee) {
            state.report_employee = report_employee;
            const temp = report_employee 
                            ? report_employee.familias.reduce((arr, f) => {
                                        arr = arr.concat(f.procesos.reduce((arr, p) => {
                                                                arr = arr.concat(
                                                                                    (p.instancias && p.instancias.length > 0) 
                                                                                    ?   p.instancias.reduce((arr, i) => {
                                                                                            arr.push({
                                                                                                nlocal: i.nlocal,
                                                                                                local: i.local
                                                                                            })
                                                                                            return arr;
                                                                                        }, [])
                                                                                    : []
                                                                                )
                                                            return arr;
                                                        }, []))
                                        return arr;
                                    }, [])
                            : [];
            state.shownlocals = temp.reduce((arr, l) => {
                                            if(arr.map((l) => l.local).indexOf(l.local) < 0) {
                                                arr.push(l);
                                            }
                                            return arr;
                                        }, []);
            return state;
        }
        return null;
    }

    handleFilter = (event) => {
        this.setState({ open: true });
    }

    handleCloseFilter = (hide) => {
        this.setState({ open: false, hide: hide });
        const tools = [toolbar(this.handleFilter, hide && hide.length === 0)];
        this.props.setTools(tools);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    timer = () => {
        clearInterval(this.state.intervalId);
        this.setState({ message: undefined });
    }

    handleTooltipOpen = (family, proceso, i) => (event) => {
        console.log(family, proceso, i);
        const message =
            <div className="flex_full_row popup bg_golden_yellow c_white padding_borders border_radius_6 center">
                <div className="flex_auto_row center ">
                    <CloseIcon className="hand margin_right_12" onClick={this.handleTooltipClose} />
                </div>
                <div className="flex_full_column">
                    {i.fecha &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'visibility_init' })}
                            {': '}
                            {i.fecha}
                        </div>
                    }
                    {i.ntrabajador &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'user' })}
                            {': '}
                            {i.ntrabajador}
                        </div>
                    }
                </div>
                <div className="flex_auto_row center margin_left_12">
                    <ProcessIcon className="hand" onClick={(event) => this.props.history.push(`/processes/${md5(family)}/${proceso}/${i.id}`)} />
                </div>
            </div>

        const intervalId = setInterval(this.timer, 10000);
        this.setState({ intervalId: intervalId, message: message });
    }

    handleTooltipClose = (event) => {
        this.setState({ message: undefined });
    }

    render() {
        const { report_employee } = this.props;
        const { message, open, shownlocals, hide } = this.state;
        if(report_employee && report_employee.familias && report_employee.familias.length > 0) {

            return(
                <div className="flex_full_column">
                    <div 
                        onScroll={this.handleScroll}
                        className="flex_full_column overflow_y_scroll showbar padding_borders">
                        <div className="flex_auto_row padding_borders_flat bg_grey_blue c_white uppercase center margin_bottom_12">
                            <span className="">{report_employee.nombreTrabajador}</span>
                        </div>
                        <div className="flex_auto_row padding_borders_flat bg_cloudy_blue c_slate uppercase center margin_bottom_12">
                            <span className="">{report_employee.desde.split(" ")[0]}</span>
                            <span className="margin_left_12 margin_right_12">{"-"}</span>
                            <span className="">{report_employee.hasta.split(" ")[0]}</span>
                        </div>
                        <div className="flex_auto_column margin_bottom_48">
                            {report_employee.familias.map((f) => 
                                <Family {...this.props} 
                                        key={randomstring()} 
                                        family={f} 
                                        hide={hide}
                                        handleTooltipOpen={this.handleTooltipOpen} 
                                        />
                            )}
                        </div>
                    </div>
                    {message}
                    {open &&
                        <FilterMenu {...this.props} shownlocals={shownlocals} hide={hide} onClose={this.handleCloseFilter} />
                    }
                </div>
            )
        } else {
            return <div/>;
        }
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/Expand.js